module.exports = __webpack_public_path__ + "media/images/icon/payment-black-68d0add8693c4f939babedd07f546353.svg";